import { render, staticRenderFns } from "./presentation-set-title.vue?vue&type=template&id=2dd4124d"
import script from "./presentation-set-title.vue?vue&type=script&lang=js"
export * from "./presentation-set-title.vue?vue&type=script&lang=js"
import style0 from "./presentation-set-title.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports